import Network from "../../utils/services/http/http/network";
import jwtDecode from 'jwt-decode';
import { _INITIAL_STATE_ } from "./reducer";
import ControlService from "../../helper/controlservice";
import { Auth } from 'aws-amplify'; /** Uncomment when aws login required */
import { azureProvider } from '../../helper/auth/Azure/configure'
import { settings } from "../../config/settings";
// import firebase from 'firebase'; /** Uncomment when firebase login required */
import AzureAuthService from "../../helper/auth/Azure/AzureAuthService";

var {
  LOGIN
} = require('../../config/constants');

function loginIsLoading(bool) {
  return {
    type: LOGIN.LOGIN_ATTEMPT,
    isLoading: bool,
    lastError: null
  };
}

function loginSuccess() {
  return {
    type: LOGIN.LOGIN_SUCCESSFULLY,
    lastError: null
  };
}

function loginFailed(lastError) {
  return {
    type: LOGIN.LOGIN_FAILED,
    lastError,
    hasError: lastError !== undefined
  };
}
function logout(resetNavigation) {
  return dispatch => {
    dispatch({
      type: LOGIN.LOGIN_LOGOUT,
      ..._INITIAL_STATE_,
      resetNavigation: resetNavigation
    });
  };
}
function resetLoginControlVars() {

  return dispatch => {
    dispatch({
      type: LOGIN.LOGIN_RESET_CONTROL_VARS,
      hasError: false
    });
  };
}
function resetNavBar(isNavBarOpen) {
  return {
    type: LOGIN.LOGIN_RESET_NAV_BAR,
    isNavBarOpen: isNavBarOpen
  }
}
function authSetToken(token) {
  return {
    type: LOGIN.AUTH_SET_TOKEN,
    token
  };
}

function authDiscardToken() {
  return {
    type: LOGIN.AUTH_DISCARD_TOKEN
  };
}

function authSetMenu(menu) {
  return {
    type: LOGIN.SET_MENU,
    menu: menu
  }
}
function doLogin(userValues) {
  return async dispatch => {
    debugger;
    dispatch(loginIsLoading(true));
    let accessToken = {};
    if (userValues.type == 'firebase') {
      try {
        // var response = firebase.auth();
        // var response = firebase.auth().currentUser;
        firebase.auth().onAuthStateChanged(response => {

          if (response) {
            accessToken.apikey = "";
            // accessToken.accesstoken = "";
            accessToken.refreshtoken = response.refreshToken;
            accessToken.loginMethod = userValues.loginservice;

            response.getIdTokenResult().then((result) => {

              accessToken.accesstoken = result.token;
              let user = {
                id: result.claims.sub,
                First_name: "",
                email: result.claims.email,
                name: result.claims.name,
                IndexToken: "",
                isEnabled: true,
                groups: "default",
                companyid: "",
                OrgType: "",
                ActiveGroupStr: "default",
                ActiveGroup: { Name: "default" },
                roles: [],
                AdminRoles: []
              }
              accessToken.user = user;
              dispatch(authSetToken(accessToken));
              dispatch(loginIsLoading(false));
              dispatch(loginSuccess());

            });
          } else {
            dispatch(authSetToken({}));
            dispatch(loginIsLoading(false));
            window.location.href = "";
          }
        })
      }
      catch (ex) { }
    } else if (userValues.type == 'azurenavigator') {
      if (settings.REACT_APP_ENABLE_PERSONA == "yes") {
        try {
          const query = new URLSearchParams(window.location.search);
          var token = query.get('code')
          var headers = [];
          Network().get(azureProvider.AccessTokenUrl + "?code=" + token + "&redirecturl=" + window.location.origin + "&url=" + settings.REACT_APP_AZURE_FUNCTION_ENDPOINT, null, accessToken, headers, { "enablecors": false })
            .then(res => {

              var response = res.data;
              accessToken.loginMethod = userValues.loginservice;
              let decodedIdToken = jwtDecode(response.id_token);
              if (userValues.loginservice === settings.LOGINMETHOD.AZUREAD) {
                let user = {
                  id: decodedIdToken.oid,
                  First_name: decodedIdToken.given_name ? decodedIdToken.given_name : "",
                  Last_name: decodedIdToken.family_name ? decodedIdToken.family_name : "",
                  name: decodedIdToken.name,
                  email: decodedIdToken.email,
                  IndexToken: response.id_token,
                  isEnabled: true,
                  groups: "default",
                  companyid: "",
                  OrgType: "",
                  ActiveGroupStr: "default",
                  ActiveGroup: { Name: "default" },
                  roles: ControlService().decodeRoles(decodedIdToken.roles),
                  AdminRoles: ControlService().decodeRoles(decodedIdToken.roles)
                }
                accessToken.apikey = response.id_token;
                accessToken.user = user;
              } else {
                let user = {
                  id: decodedIdToken.oid,
                  First_name: decodedIdToken.given_name ? decodedIdToken.given_name : "",
                  Last_name: decodedIdToken.family_name ? decodedIdToken.family_name : "",
                  name: decodedIdToken.name,
                  email: decodedIdToken.email,
                  IndexToken: response.id_token,
                  isEnabled: true,
                  groups: "default",
                  companyid: "",
                  OrgType: "",
                  ActiveGroupStr: "default",
                  ActiveGroup: { Name: "default" },
                  roles: ControlService().decodeRoles(decodedIdToken.extension_roles),
                  AdminRoles: ControlService().decodeRoles(decodedIdToken.extension_roles)
                }
                accessToken.apikey = response.idToken.rawIdToken;
                accessToken.user = user;
              }
              accessToken.expiresOn = response.expiresOn;
              accessToken.accesstoken = response.access_token;
              accessToken.XZUMOAUTH = res.data.authenticationToken;
              accessToken.user.companyid = res.data.orgid;
              dispatch(authSetToken(accessToken));
              dispatch(loginIsLoading(false));
              dispatch(loginSuccess());
            }).catch(e => {
              dispatch(loginIsLoading(false));
              dispatch(loginSuccess());
              dispatch(loginFailed(e));
            });

        } catch (e) {

          dispatch(loginIsLoading(false));
          dispatch(loginFailed(e));
        }
      } else {
        var azureAuthService = new AzureAuthService();
        var tokenResponse = await azureAuthService.init(() => dispatch(loginIsLoading(false)));
        if (tokenResponse) {
          let user = {};
          accessToken.loginMethod = userValues.loginservice;
          if (userValues.loginservice === settings.LOGINMETHOD.AZUREAD) {
            user = {
              id: tokenResponse.idTokenClaims.sub,
              First_name: tokenResponse.idTokenClaims.first_name ? tokenResponse.idTokenClaims.first_name : tokenResponse.idTokenClaims.name,
              Last_name: tokenResponse.idTokenClaims.last_name ? tokenResponse.idTokenClaims.last_name : "",
              name: tokenResponse.idTokenClaims.name,
              email: tokenResponse.idTokenClaims.preferred_username,
              IndexToken: tokenResponse.idToken.rawIdToken,
              isEnabled: true,
              groups: "default",
              companyid: "",
              OrgType: "",
              ActiveGroupStr: "default",
              ActiveGroup: { Name: "default" },
              roles: ControlService().decodeRoles(tokenResponse.idTokenClaims.roles),
              AdminRoles: ControlService().decodeRoles(tokenResponse.idTokenClaims.roles)
            }
            accessToken.apikey = tokenResponse.idToken.rawIdToken;
            accessToken.user = user;
          } else {
            user = {
              id: tokenResponse.idTokenClaims.sub,
              First_name: tokenResponse.idTokenClaims.given_name,
              Last_name: tokenResponse.idTokenClaims.family_name,
              name: tokenResponse.idTokenClaims.name,
              email: Array.isArray(tokenResponse.idTokenClaims.emails) ? tokenResponse.idTokenClaims.emails[0] : "",
              IndexToken: tokenResponse.idToken,
              isEnabled: true,
              groups: "default",
              companyid: "",
              OrgType: "",
              ActiveGroupStr: "default",
              ActiveGroup: { Name: "default" },
              roles: ControlService().decodeRoles(tokenResponse.idTokenClaims.extension_roles),
              AdminRoles: ControlService().decodeRoles(tokenResponse.idTokenClaims.extension_roles)
            }
          }
          accessToken.apikey = tokenResponse.idToken;
          accessToken.user = user;

          accessToken.expiresOn = tokenResponse.expiresOn;
          accessToken.accesstoken = tokenResponse.accessToken;
          dispatch(authSetToken(accessToken));
          dispatch(loginIsLoading(false));
          dispatch(loginSuccess());
        } else {
          dispatch(loginIsLoading(false));
        }
      }
    } else if (userValues.type == 'awsnavigator') {
      Auth.currentAuthenticatedUser({
        bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      }).then(response => {
        accessToken = response;
        debugger;
        let user = {
          id: response.attributes.sub,
          First_name: response.attributes.email,
          email: response.attributes.email,
          name: response.attributes.last_name + ' ' + response.attributes.last_name,
          IndexToken: response.signInUserSession.idToken,
          isEnabled: true,
          groups: "default",
          ActiveGroupStr: "default",
          ActiveGroup: { Name: "default" },
          roles: response.signInUserSession.accessToken.payload["cognito:groups"],
          AdminRoles: response.signInUserSession.accessToken.payload["cognito:groups"]
        }
        accessToken.user = user;
        accessToken.apikey = response.signInUserSession.idToken.jwtToken;
        accessToken.accesstoken = response.signInUserSession.idToken.jwtToken;
        accessToken.refreshtoken = response.signInUserSession.refreshToken.token;
        accessToken.loginMethod = userValues.loginservice;
        dispatch(authSetToken(accessToken));
        dispatch(loginIsLoading(false));
        dispatch(loginSuccess());
      })
        .catch(err => {
          // dispatch(loginFailed(err))
          dispatch(loginIsLoading(false));
          window.location.href = "/"
        });
    } else {
      Network().login(userValues.email, userValues.password)
        .then(response_token => {
          accessToken = { "accesstoken": response_token.access_token, "apikey": response_token.id_token };
          if (accessToken == null)
            throw new Error("Received accessToken was empty");

          let expiresIn = response_token.expires_in;

          let tokenExpiryDate = new Date();
          tokenExpiryDate.setSeconds(tokenExpiryDate.getSeconds() + expiresIn);
          accessToken.loginMethod = null;

          let decodedIdToken = jwtDecode(response_token.id_token);
          let user = {
            id: decodedIdToken.sub,
            First_name: decodedIdToken.Fist_name,
            Last_name: decodedIdToken.Last_name,
            name: decodedIdToken.Fist_name + ' ' + decodedIdToken.Last_name,
            ActiveGroupStr: decodedIdToken.ActiveGroup,
            ActiveGroup: { Name: decodedIdToken.ActiveGroup },
            email: decodedIdToken.email,
            groups: decodedIdToken.groups,
            phoneNumber: decodedIdToken.phone,
            roles: ControlService().decodeRoles(decodedIdToken.role),
            LastLogin: decodedIdToken.LastLogin,
            Plan: decodedIdToken.Plan,
            IndexToken: decodedIdToken.IndexToken,
            BlobFolder: decodedIdToken.BlobFolder
          }
          // if (decodedIdToken.BlobFolder) {
          //   accessToken.loginMethod = 'azuread';
          // }
          user.isEnabled = true
          // Fetch Admin Role
          let url = "api/authorization/getadminroles";
          let apiparam = {};
          ControlService().loadModelData(url, apiparam, accessToken)
            .then(Roles => {
              user.AdminRoles = Roles;
              accessToken.user = user;
              dispatch(authSetToken(accessToken));
              dispatch(loginIsLoading(false));
              dispatch(loginSuccess());
            })
            .catch(error => {
              accessToken.user = user;
              dispatch(loginSuccess());
              dispatch(authSetToken(accessToken));
              dispatch(loginIsLoading(false));
              dispatch(loginFailed(error.message + " getadminroles"));
            });
        })
        .catch((error) => {
          dispatch(loginIsLoading(false));
          dispatch(loginFailed(error.message + " login"));
        });
    }
  };
}

export {
  loginIsLoading,
  loginSuccess,
  loginFailed,
  logout,
  resetLoginControlVars,
  authSetToken,
  authDiscardToken,
  authSetMenu,
  doLogin,
  resetNavBar
};